import { alpha } from "@mui/material";
import { ColorConfig } from "./WeeklyHeatMap.types";

// Utility function to generate color with intensity
export const getColorWithIntensity = (
  intensity: number,
  colorConfig: ColorConfig,
  palette: { emptyColor: string; mode: "light" | "dark" }
) => {
  if (intensity === 0) {
    return colorConfig.emptyColor || alpha(palette.emptyColor, 0.1);
  }

  const [h, s] = colorConfig.baseColor;
  // Adaptive lightness based on theme mode
  // const baseLightness = palette.mode === "dark" ? 20 : 90;
  // const range = palette.mode === "dark" ? 60 : -60;
  const baseLightness = 90;
  const range = -60;

  const lightness = baseLightness + intensity * range;
  return `hsl(${h}, ${s}%, ${Math.max(10, Math.min(90, lightness))}%)`;
}; // Utility function to determine if white text is needed

export const needsWhiteText = (intensity: number, colorConfig: ColorConfig) => {
  return (
    (colorConfig.needsContrastOnHighIntensity && intensity > 0.5) ||
    intensity > 0.6
  );
};
